export default class herramienta{
	constructor($scope,
				$routeParams,
				method,
                herramientasService,
				$location,
                $uibModal,
				toastr
				){
		this.scope    = $scope;
		this.location = $location;
		this.toastr = toastr;
        this.modal = $uibModal;
		switch (method) {
			case 'list':
				this.list(herramientasService);
			break;
			case 'new':
				this.create(herramientasService);
			break;
			case 'view':
				this.view($routeParams,
                    herramientasService);
			break;
		}
	}

	list(herramientasService){

        let self = this.scope;
        herramientasService.getAll().then((resp, err) => {
			self.herramienta = resp.data.message;
		});

        self.getItemPage = (item) => {
            let index = self.herramienta.indexOf(item);
            let pageNumber = Math.floor(index / 5) + 1;
            return pageNumber;
        };

        self.eliminar = this.eliminar.bind(this, herramientasService);

        /*
        this.scope.inAction = false;
		this.scope.eliminar = (id, index) => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                herramientasService.delete({_id: id}).then((resp) => {
                    this.toastr.success('Herramienta eliminada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    window.location.reload();
                })
				.catch((err) => {
                    this.scope.inAction = false;
					this.toastr.error('Error', 'Error al eliminar herramienta!', {
						timeOut: 2000,
						closeButton: true
					});
				});
            }
		};*/
	}

	create(herramientasService){

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                herramientasService.save(this.scope.herramienta).then((resp) => {
                    this.toastr.success('Herramienta creada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/herramienta');
                })
				.catch((err) => {
                    this.scope.inAction = false;
					this.toastr.error('Error', 'Error al crear herramienta!', {
						timeOut: 2000,
						closeButton: true
					});
				});
            }
		};
	}

	view($routeParams,
         herramientasService){

		this.scope.aux = {};
        herramientasService.getById({_id: $routeParams.id}).then((resp) => {
			this.scope.herramienta = resp.data.message;
		}).catch((er) => {
			console.log(er);
		});

        this.scope.inAction = false;
		this.scope.guardar = () => {
            if (!this.scope.inAction) {
                this.scope.inAction = true;
                herramientasService.update(this.scope.herramienta).then((resp) => {
                    this.toastr.success('Herramienta modificada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                    this.location.path('/herramienta');
                })
				.catch((err) => {
                    this.scope.inAction = false;
					this.toastr.error('Error', 'Error al modificar herramienta!', {
						timeOut: 2000,
						closeButton: true
					});
				});
            }
		};
	}

    eliminar(service,object, page, index) {
        let self = this;
        let templateModal = `
			    <div class="modal-content">
			      <div class="modal-header">
			        <h4 class="modal-title" id="myModalLabel">Eliminar Herramienta</h4>
			      </div>
			      <div class="modal-body">
                		¿Quiere eliminar la herramienta: {{ctr.nombre}}?
			      </div>
			      <div class="modal-footer">
			        <button type="button" class="btn btn-default" ng-click="ctr.no()">NO</button>
			        <button type="button" class="btn btn-primary" ng-click="ctr.si()">SI</button>
			      </div>
			    </div>
		`;
        let modal = this.modal.open({
            animation: true,
            ariaLabelledBy: 'modal-title',
            template: templateModal,
            controller: function () {
                let vm = this;
                vm.nombre = object.nombre;
                this.no = () => {
                    let data = {
                        delete: false
                    };
                    modal.close(data);
                };

                this.si = () => {
                    let data = {
                        delete: true,
                        index: (page - 1) * 5 + index
                    };
                    modal.close(data);
                };
            },
            controllerAs: 'ctr',
            size: 'md'
        });

        modal.result.then((resp) => {
            if (resp.delete) {
                let indexObject = resp.index;
                self.inAction = true;
                service.delete({_id: object._id}).then((resp) => {
                    self.scope.herramienta.splice(indexObject, 1);
                    self.inAction = false;
                    this.toastr.success('Herramienta eliminada correctamente!', 'Success!', {
                        timeOut: 2000,
                        closeButton: true
                    });
                })
                    .catch((err) => {
                        self.inAction = false;
                        this.toastr.error('Error al eliminar la Herramienta!','Error',  {
                            timeOut: 2000,
                            closeButton: true
                        });
                    });
            }

        }, (exit) => {
            console.log('modal close');
        });
    }
}


// WEBPACK FOOTER //
// ./app/js/controllers/herramienta/herramienta.js